export const breakpoints = {
  tablet: '700px',
  desktop: '1040px'
}



// WEBPACK FOOTER //
// ./src/styled-components/constants.js